@for (navigation of routerUtilService.navigations; track navigation) {
  <ng-container
    *ngTemplateOutlet="recursiveMenuTmpl; context: { navigation: navigation }"
  >
  </ng-container>
}

<div (click)="logout(); togglePage()" class="logout-btn">
  <div class="logout-wrap">
    <ion-label>
      <span>
        <svg
          fill="none"
          height="20"
          viewBox="0 0 20 20"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" fill="#9C6741" fill-opacity="0.61" r="10" />
          <path
            d="M12.5148 11.8017C12.4203 11.7069 12.373 11.5953 12.373 11.4667C12.373 11.3381 12.4203 11.2265 12.5148 11.1317L13.1627 10.4821H10.2469C10.112 10.4821 9.9989 10.4364 9.90778 10.3451C9.81666 10.2537 9.7711 10.1404 9.7711 10.005C9.7711 9.86969 9.81666 9.75634 9.90778 9.66499C9.9989 9.57363 10.112 9.52796 10.2469 9.52796H13.1425L12.4743 8.85802C12.3865 8.77681 12.3444 8.67192 12.3477 8.54335C12.3511 8.41478 12.4 8.30312 12.4945 8.20838C12.589 8.11364 12.7038 8.06797 12.8388 8.07135C12.9738 8.07473 13.0885 8.12379 13.183 8.21853L14.6409 9.68021C14.6881 9.72758 14.7236 9.78003 14.7472 9.83755C14.7708 9.89507 14.7826 9.95428 14.7826 10.0152C14.7826 10.0761 14.7708 10.1353 14.7472 10.1928C14.7236 10.2503 14.6881 10.3028 14.6409 10.3502L13.183 11.8118C13.0952 11.8998 12.9873 11.9438 12.859 11.9438C12.7308 11.9438 12.616 11.8964 12.5148 11.8017V11.8017ZM7.91835 13.913C7.65512 13.913 7.42901 13.82 7.24002 13.6339C7.05104 13.4478 6.95654 13.2228 6.95654 12.9588V7.05122C6.95654 6.7873 7.05104 6.56061 7.24002 6.37113C7.42901 6.18165 7.65512 6.08691 7.91835 6.08691H10.4596C10.5945 6.08691 10.7076 6.13598 10.7987 6.2341C10.8898 6.33222 10.9354 6.44557 10.9354 6.57414C10.9354 6.70948 10.8898 6.82283 10.7987 6.91419C10.7076 7.00554 10.5945 7.05122 10.4596 7.05122H7.91835V12.9588H10.4596C10.5945 12.9588 10.7076 13.0045 10.7987 13.0959C10.8898 13.1872 10.9354 13.3006 10.9354 13.4359C10.9354 13.5713 10.8898 13.6846 10.7987 13.776C10.7076 13.8673 10.5945 13.913 10.4596 13.913H7.91835Z"
            fill="white"
          />
        </svg>
      </span>
      Logout
    </ion-label>
    <span><ion-icon name="arrow-forward"></ion-icon></span>
  </div>
</div>

<ng-template #recursiveMenuTmpl let-navigation="navigation">
  <div class="side-menu">
    @switch (navigation?.type) {
      @case ("group") {
        @if (navigation.permissions | permissions | async) {
          <ion-accordion-group
            (ionChange)="onAccordionGroupChange($event, navigation)"
            [value]="
              navigation?.active
                ? [$safeNavigationMigration(navigation?.id)]
                : []
            "
            multiple="true"
          >
            <ion-accordion [value]="$safeNavigationMigration(navigation?.id)">
              <ion-item
                class="title-header"
                color="none"
                lines="none"
                slot="header"
              >
                <span><ion-icon name="{{ navigation?.name }}"></ion-icon></span>
                <ion-label>{{ navigation?.title }}</ion-label>
              </ion-item>
              <div class="" slot="content">
                @if (navigation?.childrens?.length > 0) {
                  @for (
                    nestedNavigation of navigation?.childrens;
                    track nestedNavigation
                  ) {
                    <ng-container
                      *ngTemplateOutlet="
                        recursiveMenuTmpl;
                        context: { navigation: nestedNavigation }
                      "
                    >
                    </ng-container>
                  }
                }
              </div>
            </ion-accordion>
          </ion-accordion-group>
        }
      }
      @case ("item") {
        @if (navigation.permissions | permissions | async) {
          <ion-item
            (click)="togglePage()"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLinkActive]="'active'"
            [routerLink]="$safeNavigationMigration(navigation?.url)"
            class="title-subheader"
            color="none"
            lines="none"
          >
            {{ navigation?.title }} <span class="dot"></span>
          </ion-item>
        }
      }
    }
  </div>
</ng-template>
